import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const acceptBulkEmployeeUpdatesKey = 'acceptBulkEmployeeUpdates';

export interface AcceptBulkEmployeeUpdatesState {
  acceptBulkEmployeeUpdatesResponse: any;
  acceptBulkEmployeeUpdatesFailure: any;
  loaded: boolean;
}

export const initialState: AcceptBulkEmployeeUpdatesState = {
  acceptBulkEmployeeUpdatesResponse: undefined,
  acceptBulkEmployeeUpdatesFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.acceptBulkEmployeeUpdatesSuccess, (state, action) => ({
    ...state,
    acceptBulkEmployeeUpdatesResponse: action.response,
    loaded: true
  })),

  on(actions.acceptBulkEmployeeUpdatesFailure, (state, action) => ({
    ...state,
    acceptBulkEmployeeUpdatesFailure: action.error
  }))
);

export const acceptBulkEmployeeUpdates = (state: AcceptBulkEmployeeUpdatesState) => state.acceptBulkEmployeeUpdatesResponse;
